module.exports = __webpack_public_path__ + "static/media/CFIT.7a5f3acd.svg";